export default "/images/vendor/flag-icon-css/flags/1x1/br.svg?f1b8e364a7dd0a8f3fb51316f7cac573";